import type { BadgeVariant } from '@tkpod/ui';
import type { OptionUIType } from '@tkpod/shared';

export const UI_TYPE_BADGE: Record<string, BadgeVariant> = {
  COLOR_SWATCH: 'purple',
  BUTTON_GROUP: 'primary',
  DROPDOWN: 'default',
  RADIO: 'success',
};

export const UI_TYPE_OPTIONS: { value: OptionUIType; label: string }[] = [
  { value: 'DROPDOWN', label: 'Dropdown' },
  { value: 'COLOR_SWATCH', label: 'Color Swatch' },
  { value: 'BUTTON_GROUP', label: 'Button Group' },
  { value: 'RADIO', label: 'Radio' },
  { value: 'IMAGE_CARD', label: 'Image Card' },
];
